import { render, staticRenderFns } from "./Landing.vue?vue&type=template&id=4ab26cc6&scoped=true&"
import script from "./Landing.vue?vue&type=script&lang=js&"
export * from "./Landing.vue?vue&type=script&lang=js&"
import style0 from "./style.scss?vue&type=style&index=0&id=4ab26cc6&lang=scss&scoped=true&"
import style1 from "./stylev4.scss?vue&type=style&index=1&id=4ab26cc6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ab26cc6",
  null
  
)

component.options.__file = "Landing.vue"
export default component.exports